import { render, staticRenderFns } from "./RenameDialog.vue?vue&type=template&id=28ca2f39"
import script from "./RenameDialog.vue?vue&type=script&lang=js"
export * from "./RenameDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports